module.exports = __webpack_public_path__ + "img/white-honda-civic-r.a50f7fa2.jpg";